<template>
  <div class="container">
    <h1 v-if="user">
      {{ user.username }}'s profile
    </h1>
    <br>
    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">
          User access token for
        </div>
        <v-card>
          <v-card-text>
            <b>Authorization Header:</b>
            <br>
            <br>
            {{ userAccessToken }}
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <div slot="header">
          Multifactor Authentication
        </div>
        <v-card>
          <v-card-text>
            <amplify-set-mfa :mfa-config="mfaConfig" />
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
export default {
  name: 'Profile',

  data: () => ({
    userAccessToken: '',
    mfa: false,
  }),
  computed: {
    user() {
      return this.$store.state.userStore.user;
    },
    mfaConfig() {
      const that = this;

      return {
        mfaDescription: "My app's mfa description!!",
        mfaTypes: ['TOTP', 'SMS', 'None'],
        cancelHandler() {
          that.toggleAccordion('mfa');
        },
      };
    },
    profilePicAccordion() {
      return {
        'is-closed': !this.profilePic,
        'is-primary': this.profilePic,
        'is-dark': !this.profilePic,
      };
    },
    mfaAccordion() {
      return {
        'is-closed': !this.mfa,
        'is-primary': this.mfa,
        'is-dark': !this.mfa,
      };
    },
  },
  mounted() {
    const { jwtToken } = this.user.signInUserSession.idToken;
    this.userAccessToken = jwtToken;
  },
  methods: {
    toggleAccordion(el) {
      this[el] = !this[el];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/profile/Profile.vue